import { Activite } from "@/models";
import ActiviteService from "@/services/activite.service";
import { Module, VuexModule, Action, Mutation } from "vuex-class-modules";

/** Holds the currently-loaded single activity (detail view). */
@Module
export class Activites extends VuexModule {
  private _activite: Activite | null = null;

  @Mutation
  private setActivite(activite: Activite) {
    this._activite = activite;
  }

  /**
   * Loads an activity by id into the store.
   * @returns `true` if found and loaded, `false` otherwise.
   */
  @Action
  public async activite(id: string): Promise<boolean> {
    const activite = await ActiviteService.activite(id);
    if (activite) {
      this.setActivite(activite);
      return true;
    } else {
      return false;
    }
  }

  /** The currently-loaded activity, or `null` if none loaded. */
  get getActivite(): Activite | null {
    return this._activite;
  }
}
